import React from 'react';
import AvailabilityCalendar from '../components/AvailabilityCalendar';
import { useLocalization } from '../context/LocalizationContext';
import styles from '../styles/UserDashboard.module.css';

const AdminAvailabilityPage = () => {
  const { t } = useLocalization();

  return (
    <div className={styles.container}>
      <h1>{t('admin_availability_title', "All Users' Availability")}</h1>
      <AvailabilityCalendar isAdmin />
    </div>
  );
};

export default AdminAvailabilityPage;
